import { useNavigate, useRoutes } from 'react-router-dom';
import router from 'src/router';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';

import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import { useEffect } from 'react';
import { closeSnackbar, SnackbarProvider } from 'notistack';
import { CustomerProvider } from './content/pages/customer/customerData';
import { ServicePartnerProvider } from './content/pages/servicePartner/servicePatnerData';
import { UserProvider } from './content/pages/settings/userManagement/user/userContext';
import { TokenExpiredModal } from './content/pages/auth/TokenExpiredModal';
import { SalesPartnerProvider } from './content/pages/settings/SalesPartner/SalesPartnerData';
import { NotificationProvider } from './contexts/NotificationContext';

function App() {
  const content = useRoutes(router);
  const navigate = useNavigate();
  // useEffect(() => {
  //   const url = location.href.replace(/^.*\/\/[^\/]+/, '');
  //   if (url == '/') {
  //     navigate('dashboards');
  //   } else {
  //     navigate(url);
  //   }
  // }, [1]);

  return (
    <ThemeProvider>
      <CustomerProvider>
        <UserProvider>
          <NotificationProvider>
            <SnackbarProvider
              maxSnack={3}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              autoHideDuration={1500}
              transitionDuration={{ enter: 200, exit: 200 }}
            >
              <ServicePartnerProvider>
                <SalesPartnerProvider>
                  {/* <LocalizationProvider dateAdapter={AdapterDateFns}> */}
                  <CssBaseline />
                  <TokenExpiredModal />
                  {content}
                  {/* </LocalizationProvider> */}
                </SalesPartnerProvider>
              </ServicePartnerProvider>
            </SnackbarProvider>
          </NotificationProvider>
        </UserProvider>
      </CustomerProvider>
    </ThemeProvider>
  );
}
export default App;
